import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/ui/Reveal";
import { localizedPath } from "@/lib/helpers";
import { mediaUrl } from "@/lib/api";

export function CTABanner({ title, subtitle, image }) {
  const { t } = useTranslation();
  const { lang = "en" } = useParams();
  return (
    <section className="relative overflow-hidden" data-testid="cta-banner">
      {image ? (
        <img src={mediaUrl(image, { w: 1600, fmt: "webp", q: 75 })} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
      ) : null}
      <div className="absolute inset-0 bg-ink-900/85" />
      <div className="absolute inset-0 tech-grid opacity-40" />
      <div className="absolute top-0 left-0 w-full h-px bg-cyan/60" />
      <div className="container-x relative py-20 md:py-28 text-center">
        <Reveal>
          <h2 className="h-display text-cloud text-[clamp(2rem,4.5vw+0.5rem,3.75rem)] max-w-3xl mx-auto">{title}</h2>
        </Reveal>
        {subtitle ? (
          <Reveal delay={0.1}>
            <p className="mt-5 text-steel max-w-xl mx-auto text-lg">{subtitle}</p>
          </Reveal>
        ) : null}
        <Reveal delay={0.2}>
          <Link to={localizedPath(lang, "/contact")} className="btn-primary mt-9" data-testid="cta-banner-button">
            {t("cta.contactUs")} <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
